import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Alert, Autocomplete, Skeleton } from "@material-ui/lab";
import Notification from "../notification/Notification";
import { useTranslation } from "react-i18next";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, ROLES, STANDARD_ERRORS_WAY } from "../../../utils/consts";

const ClientsSelect = ({
  checkedUser,
  setCheckedUser,
  onlyClients = true,
  label = false,
  isObject = false
}) => {
  const { t } = useTranslation("otherInterface");
  const [users, setUsers] = useState([]);
  const [fetching, setFetching] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchClients = () => {
    setFetching(true);

    let filterData = "?pagination=false&order[email]=asc";

    if (onlyClients) {
      filterData = filterData + "&roles=" + ROLES.ROLE_USER;
    }

    axios.get("/api/users" + filterData, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setUsers(response.data["hydra:member"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => {
      setFetching(false);
    });
  };

  useEffect(() => {
    fetchClients();
  }, []);

  if (fetching) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(users).length === 0) {
    return <Alert severity="warning">{t("user.empty")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <Autocomplete
          options={isObject ? users : users.map(user => user.email) || []}
          value={checkedUser || null}
          onChange={(event, user) => setCheckedUser(user)}
          getOptionLabel={(option) => isObject ? option?.email : option}
          renderInput={(params) => (
            <TextField {...params} label={label} />
          )}
          blurOnSelect
          ListboxProps={{ style: { overflowX: "hidden" } }}
        />
      </FormControl>
    </>
  );
};

export default ClientsSelect;